import { Component, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'tv-list-section-header',
  templateUrl: './list.section.header.component.html',
  styleUrls: [
    './list.section.header.component.css'
  ]
})
export class ListSectionHeaderComponent {
  @Input() public title = '';

  constructor(private titleService: Title) {
    this.setTitle(this.title);
  }

  private setTitle(title: string) {
    this.titleService.setTitle(title);
    this.title = title;
  }
}
